<template>
  <div>
    <el-card>
      <div>测试input和button的size</div>
      <el-row>
        <AggregateItem v-model="input.value1" :item="{component:'input',size:'small'}"></AggregateItem>
        <AggregateItem v-model="input.value2" :item="{component:'input',size:'default'}"></AggregateItem>
        <AggregateItem v-model="input.value3" :item="{component:'input',size:'large'}"></AggregateItem>
        <AggregateItem v-model="input.value4" :item="{component:'input',size:'xl'}"></AggregateItem>
        <AggregateItem v-model="input.value5" :item="{component:'input',size:'xxl'}"></AggregateItem>
      </el-row>
      <br/>
      <br/>
      <el-row>
        <FrameButton :button="{label:'按钮：small',size:'small'}"></FrameButton>
        <FrameButton :button="{label:'按钮：default',size:'default',type:'primary'}"></FrameButton>
        <FrameButton :button="{label:'按钮：large',size:'large',plain:true}"></FrameButton>
        <FrameButton :button="{label:'按钮：xl',size:'xl'}"></FrameButton>
        <FrameButton :button="{label:'按钮：xxl',size:'xxl'}"></FrameButton>
      </el-row>
    </el-card>
    <el-card>
      <div>测试级联下拉框</div>
      <el-row>
        <AggregateItem v-model="cascader.value1" :item="cascader.item1"></AggregateItem>
        <AggregateItem v-model="cascader.value2" :item="cascader.item2"></AggregateItem>
      </el-row>
    </el-card>
    <el-card>
      <div>测试日期</div>
      <div>{{ datePicker.value1 }}======{{ datePicker.value2 }}======{{ datePicker.value3 }}======{{ datePicker.value4 }}</div>
      <el-row>
        <AggregateItem v-model="datePicker.value1" :item="{component:'date_picker',valueFormat:'YYYY/MM/DD'}"></AggregateItem>
        <AggregateItem v-model="datePicker.value2" :item="{component:'date_picker',type:'daterange'}"></AggregateItem>
        <AggregateItem v-model="datePicker.value3" :item="{component:'date_picker',type:'datetime',valueFormat:'YYYY-MM-DD hh:mm:ss'}"></AggregateItem>
        <AggregateItem v-model="datePicker.value4" :item="{component:'date_picker',type:'datetimerange',valueFormat:'YYYY-MM-DD hh:mm:ss'}"></AggregateItem>
      </el-row>
    </el-card>
    <el-card>
      <div>测试下拉框</div>
      <div>{{ select.value1 }}======{{ select.value2 }}</div>
      <el-row>
        <AggregateItem v-model="select.value1" :item="select.item1"></AggregateItem>
        <AggregateItem v-model="select.value2" :item="select.item2"></AggregateItem>
      </el-row>
    </el-card>
    <el-card>
      <div>测试input和textarea</div>
      <div>{{ input1.value1 }}======{{ input1.value2 }}======{{ input1.value3 }}</div>
      <el-row>
        <AggregateItem v-model="input1.value1" :item="{component:'input'}"></AggregateItem>
        <AggregateItem v-model="input1.value2" :item="{component:'input',type:'textarea',autosize:true}"></AggregateItem>
        <AggregateItem v-model="input1.value3" :item="{component:'input',type:'textarea',autosize:{minRows:2,maxRows:4}}"></AggregateItem>
      </el-row>
    </el-card>

    <el-card>
      <div>测试拍照</div>
      <div>{{ photo.fileIds }}</div>
      <el-row>
        <AggregateItem v-model="photo.fileIds" :item="photo.item" :file-list="photo.item.fileList"></AggregateItem>
        <el-button @click="photo.fileIds=[]">清空</el-button>
        <el-button @click="photo.fileIds.shift()">删除第一个</el-button>
      </el-row>
    </el-card>

    <el-card>
      <div>测试图片查看</div>
      <el-row>
        <AggregateItem :item="image.item1"></AggregateItem>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <AggregateItem :item="image.item2"></AggregateItem>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <AggregateItem :item="image.item3"></AggregateItem>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <AggregateItem :item="image.item4"></AggregateItem>
      </el-row>
    </el-card>

    <el-card>
      <div>测试文件上传</div>
      <div>{{ fileUpload.fileIds }}</div>
      <el-row>
        <AggregateItem v-model="fileUpload.fileIds" :item="fileUpload.item" :file-list="fileUpload.item.fileList"></AggregateItem>
        <el-button @click="fileUpload.fileIds=[]">清空</el-button>
        <el-button @click="fileUpload.fileIds.shift()">删除第一个</el-button>
      </el-row>
    </el-card>
    <el-card>
      <div>测试图片上传并带出原有图片</div>
      <div>{{ imageUpload.fileIds }}</div>
      <el-row>
        <AggregateItem v-model="imageUpload.fileIds" :item="imageUpload.item" :file-list="imageUpload.item.fileList"></AggregateItem>
        <el-button @click="imageUpload.fileIds=[]">清空</el-button>
        <el-button @click="imageUpload.fileIds.shift()">删除第一个</el-button>
      </el-row>
    </el-card>

    <el-card>
      <div>测试下载</div>
      <el-row>
        <AggregateItem :file-list="download.item.fileList" :item="download.item"></AggregateItem>
      </el-row>
    </el-card>


  </div>


</template>

<script>

export default {
  name: "Test",
  data() {
    return {
      input: {
        value1: 'size：small',
        value2: 'size：default',
        value3: 'size：large',
        value4: 'size：xl',
        value5: 'size：xxl',
      },
      cascader: {
        item1: {
          component: 'cascader',
          multiple: true,
          dataSource: [{
            name: 'sss',
            code: '111',
            children: [{
              name: 'sss1',
              code: '1111'
            }, {
              name: 'aaa2',
              code: '2222'
            }]
          }, {
            name: 'aaa',
            code: '222'
          }]
        },
        item2: {
          component: 'cascader',
          dataSource: [{
            name: 'sss',
            code: '111'
          }, {
            name: 'aaa',
            code: '222'
          }]
        }
      },
      datePicker: {},
      select: {
        item1: {
          component: 'select',
          label_field: 'label',
          value_field: 'value',
          dataSource: [
            {label: 'label1', value: 'value1'},
            {label: 'label2', value: 'value2'},
            {label: 'label3', value: 'value3', disabled: true},
            {label: 'label4', value: 'value4'},
          ]
        },
        item2: {
          component: 'select',
          label_field: 'label',
          value_field: 'value',
          multiple: true,
          dataSource: [
            {label: 'label1', value: 'value1'},
            {label: 'label2', value: 'value2'},
            {label: 'label3', value: 'value3', disabled: true},
            {label: 'label4', value: 'value4'},
          ]
        }
      },
      input1: {},
      image: {
        item1: {
          component: 'image_viewer',
          urlList: [
            'https://fuss10.elemecdn.com/d/e6/c4d93a3805b3ce3f323f7974e6f78jpeg.jpeg',
            'https://fuss10.elemecdn.com/1/34/19aa98b1fcb2781c4fba33d850549jpeg.jpeg'
          ]
        },
        item2: {
          component: 'image_viewer',
          urlField: 'myUrl',
          fileList: [
            {myUrl: 'https://fuss10.elemecdn.com/d/e6/c4d93a3805b3ce3f323f7974e6f78jpeg.jpeg'},
            {myUrl: 'https://fuss10.elemecdn.com/1/34/19aa98b1fcb2781c4fba33d850549jpeg.jpeg'}
          ]
        },
        item3: {
          component: 'image_viewer_switch',
          urlList: [
            'https://fuss10.elemecdn.com/d/e6/c4d93a3805b3ce3f323f7974e6f78jpeg.jpeg',
            'https://fuss10.elemecdn.com/1/34/19aa98b1fcb2781c4fba33d850549jpeg.jpeg'
          ]
        },
        item4: {
          component: 'image_viewer_switch',
          urlField: 'myUrl',
          fileList: [
            {myUrl: 'https://fuss10.elemecdn.com/d/e6/c4d93a3805b3ce3f323f7974e6f78jpeg.jpeg'},
            {myUrl: 'https://fuss10.elemecdn.com/1/34/19aa98b1fcb2781c4fba33d850549jpeg.jpeg'}
          ]
        },

      },
      fileUpload: {
        item: {
          component: 'file_upload',
          limit: 3,
          url: 'frame/file/upload',
          accept: ".txt,.xlsx",
          fileList: [{
            id: '43a783e0edaf456a9a62127c0ded3f0a',
            original_name: '测试文件1.txt',
            url: "http://127.0.0.1:8088/fs/20220312/43a783e0edaf456a9a62127c0ded3f0a.jpeg"
          }],
        },
        fileIds: [],
      },
      imageUpload: {
        item: {
          component: 'image_upload',
          limit: 3,
          accept: ".jpg",
          fileList: [{
            id: '43a783e0edaf456a9a62127c0ded3f0a',
            original_name: '图片1.jpeg',
            url: "https://fuss10.elemecdn.com/d/e6/c4d93a3805b3ce3f323f7974e6f78jpeg.jpeg"
          }],
        },
      },
      photo: {
        fileIds: [],
        item: {
          component: 'take_photo',
          limit: 2,
          fileList: [{
            id: '43a783e0edaf456a9a62127c0ded3f0a',
            original_name: '图片1.jpeg',
            url: "https://fuss10.elemecdn.com/d/e6/c4d93a3805b3ce3f323f7974e6f78jpeg.jpeg"
          }],
        }
      },
      download: {
        item: {
          component: 'download',
          fileList: [
            {name: '文件1.jpeg', url: 'https://fuss10.elemecdn.com/d/e6/c4d93a3805b3ce3f323f7974e6f78jpeg.jpeg'},
            {name: '文件2.xlsx', url: 'http://127.0.0.1:8088/fs/20220326/04ad7159e59e4826ab6aaa9f8bbdfd3a.xlsx'}
          ]
        }
      }

    }
  },
  methods: {
    setImageIds(idList) {
      console.log(idList)
    }
  }
}
</script>

<style scoped>
.el-card {
  margin-bottom: 20px;
}

.el-row {
  margin-top: 20px;
}
</style>